var s = /* @__PURE__ */ ((e) => (e.MAX_LIMIT_REACHED = "maxLimitReached", e))(s || {});
const t = ["business__in", "business__notin"];
export {
  s as BusinessModalErrorType,
  t as defaultPersistentFilterKeys
};
